import { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import OurHistory from './components/OurHistory';
import Biography from './components/Biography';
import BiographyPage from './components/BiographyPage';
import SharadhaMuttPage from './components/SharadhaMuttPage';
import SivagiriPilgrimagePage from './components/SivagiriPilgrimagePage';
import OurHistoryPage from './components/OurHistoryPage';
import LeadershipPage from './components/LeadershipPage';
import GalleryPage from './components/GalleryPage';
import ConstitutionPage from './components/ConstitutionPage';
import ContactUsPage from './components/ContactUsPage';
import NewsArticlesPage from './components/NewsArticlesPage';
import LatestArticles from './components/LatestArticles';
import VideoSection from './components/VideoSection';
import Gallery from './components/Gallery';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import MembershipPage from './components/MembershipPage';
import EventCalendarPage from './components/EventCalendarPage';
import DonationPage from './components/DonationPage';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';

function App() {
  const [page, setPage] = useState('home');

  // Check URL for /admin route on mount
  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/admin') {
      setPage('admin');
    }
  }, []);

  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === '/admin') {
        setPage('admin');
      } else {
        setPage('home');
      }
    };
    
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Helper to navigate and update URL
  const navigate = (targetPage) => {
    setPage(targetPage);
    if (targetPage === 'admin') {
      window.history.pushState({}, '', '/admin');
    } else if (targetPage === 'home') {
      window.history.pushState({}, '', '/');
    }
    window.scrollTo(0, 0);
  };

  if (page === 'biography') {
    return <BiographyPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'sharadha') {
    return <SharadhaMuttPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'sivagiri') {
    return <SivagiriPilgrimagePage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'ourhistory') {
    return <OurHistoryPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'leadership') {
    return <LeadershipPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'gallery') {
    return <GalleryPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'constitution') {
    return <ConstitutionPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'contact') {
    return <ContactUsPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'news') {
    return <NewsArticlesPage onBack={() => { navigate('home'); }} onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'membership') {
    return <MembershipPage onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'eventcalendar') {
    return <EventCalendarPage onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'donation') {
    return <DonationPage onNavigate={(p) => { navigate(p); }} />;
  }

  if (page === 'admin') {
    return <AdminDashboard onNavigate={(p) => { navigate(p); }} />;
  }

  return (
    <div className="App">
      <Navbar onNavigate={(p) => { navigate(p); }} />
      <Hero />
      <OurHistory />
      <Biography
        onViewMore={() => { navigate('biography'); }}
        onViewMoreSharadha={() => { navigate('sharadha'); }}
        onViewMoreSivagiri={() => { navigate('sivagiri'); }}
      />
      <LatestArticles />
      <VideoSection />
      <Gallery />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
